import React, { Component } from 'react';
import project from '../../img/icons/project.svg';
import school from '../../img/icons/school.svg';
import transaction from '../../img/icons/transaction.svg';
import group from '../../img/icons/group.svg';
import user from '../../img/icons/user.svg';
import projectPink from '../../img/icons/project-pink.svg';
import schoolPink from '../../img/icons/school-pink.svg';
import transactionPink from '../../img/icons/transaction-pink.svg';
import groupPink from '../../img/icons/group-pink.svg';
import userPink from '../../img/icons/user-pink.svg';
import payed from '../../img/icons/payed.svg';
import notPayed from '../../img/icons/not-payed.svg';

export default class Icon extends Component {
    state = {
        src: ''
    }

    componentWillMount() {
        if (this.props.icon === 'project') {
            if (this.props.color && this.props.color === 'pink') {
                this.setState({ src: projectPink });
            } else {
                this.setState({ src: project });
            }
        }
        if (this.props.icon === 'school') {
            if (this.props.color && this.props.color === 'pink') {
                this.setState({ src: schoolPink });
            } else {
                this.setState({ src: school });
            }
        }
        if (this.props.icon === 'group') {
            if (this.props.color && this.props.color === 'pink') {
                this.setState({ src: groupPink });
            } else {
                this.setState({ src: group });
            }
        }
        if (this.props.icon === 'user') {
            if (this.props.color && this.props.color === 'pink') {
                this.setState({ src: userPink });
            } else {
                this.setState({ src: user });
            }
        }
        if (this.props.icon === 'transaction') {
            if (this.props.color && this.props.color === 'pink') {
                this.setState({ src: transactionPink });
            } else {
                this.setState({ src: transaction });
            }
        }
        if (this.props.icon === 'payed') {
            this.setState({ src: payed });
        }
        if (this.props.icon === 'not-payed') {
            this.setState({ src: notPayed });
        }
    }

    render() {
        return (
            <span className={`icon ${ this.props.className }`}>
                <img src={ this.state.src } alt="Ikon" title={ this.props.title ? this.props.title : '' } />
            </span>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/partials/Icon.js